import PropTypes from 'prop-types';
import React from 'react';

import { StyledBackdrop } from './styles';

const Backdrop = ({ transition, withColor, className, onClick, ...props }) => (
  <StyledBackdrop
    className={className}
    onClick={onClick}
    withColor={withColor}
    {...props}
  />
);

Backdrop.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  transition: PropTypes.string,
  withColor: PropTypes.bool,
};

Backdrop.defaultProps = {
  className: '',
  onClick: () => {},
  transition: undefined,
  withColor: false,
};

export default Backdrop;
